import React from 'react';
import CreationPage from '@/components/commos/CreationPage';
import { Button } from '@ab-inbev-maz/compass';
import { LegalContext } from '@/contexts/legalContext';
import { FirstStepLegal } from '@/components/legal/CreateLegal';
import { legalsService } from '@/services/legalsService';

const items = [
  {
    id: 'form',
    title: 'Información general del legal',
    Component: () => <FirstStepLegal />
  }
]

const LegalPage: React.FC = () => {
  const saveSingleLegal = (data: Record<string, any>) => {
    const { image: _image, ...legalData } = data;
    return legalsService.createLegal(legalData as { name: string; legal_text: string; color: string });
  };

  const saveButton = (isDisabled = false, isFetching: boolean) => (
    <Button
      key="save-button"
      label="Guardar nuevo legal"
      rightIcon="functionalities/save"
      variant="primary"
      disabled={ isFetching }
      type="submit"
      form="legal-general-info"
    />
  );

  const pageConfig = {
    title: "Creación de legal",
    description: "Aquí podras crear y personalizar tus reglas para la implementación de los combos.",
    tablePath: "/legals/table"
  };

  const modalConfig = {
    title: '¿Confirmar la creación de nuevo legal?',
    message: 'Estás a punto de crear un nuevo legal. Una vez guardado, quedará almacenado en el Listado de legal.',
    successText: 'Legal guardado exitosamente',
    successMessage: (legalName?: string) => `El legal "${legalName}" ha sido guardado en la librería`,
    errorText: 'Error al guardar el legal'
  };

  return (
    <CreationPage
      saveButton={saveButton}
      pageConfig={pageConfig}
      modalConfig={modalConfig}
      items={items}
      saveFunction={saveSingleLegal}
      ContextProvider={LegalContext}
    />
  );
};

export default LegalPage;
